import React from 'react'
import "./AboutCustomText.css"
import { useNavigate } from 'react-router-dom'

function AboutCustomText() {
    const navigate = useNavigate()
  return (
    <div className='AboutCustomText-container standard-padding-space'>
        <div className='container mb-4'>
            <div className='text-start content-container'>
                <h3 className={`body-heading my-2 `}>Welcome to Divitiis</h3>
                <p className={`body-heading `} style={{fontSize:"1.8rem",fontWeight:"normal"}}>
                    Dare to be you, tell it boldly.
                </p>

                <div className='mt-4'>
                    <img src='/images/creatives/about-text-2.jpg' alt='content' className='img-fluid me-lg-4 me-auto imgFloating pb-2' />


                </div>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                     Divitiis is Latin for riches — not just in the financial sense, but in the depth of your story, the clarity of your vision, and the trust you build with your audience.
                 </p>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                   We believe that true growth comes when you're brave enough to be yourself and strategic enough to communicate it with purpose. That’s where we come in.
                 </p>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                 At Divitiis, we help professionals in high-trust industries tell their story with confidence, clarity, and conviction. Through thoughtful marketing, bold messaging, and a deep understanding of your business, we help turn your authenticity into your competitive edge.
                 </p>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                    Why choose us? Because we don’t do cookie-cutter. We go deep uncovering your strengths, refining your voice, and aligning every move to your unique vision. It’s thoughtful, high-touch, and built for results.
                 </p>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                   With expertise supporting top-tier professionals across finance, real estate, wellness, and more, Divitiis is your partner in marketing that makes a lasting impact.
                 </p>
                 <p className={`body-paragraph color-dark pb-3 mb-0`}>
                     <span style={{fontWeight:"700"}}>This is where strategy meets soul and that’s where the real wealth begins.</span>
                 </p>
                 {/* <p className={`body-paragraph color-dark pb-3 mb-0`}>
                     At Divitiis, professionals develop a brand presence that reflects who they are and resonates with who they serve.
                 </p>
                 <p className={`body-paragraph color-dark mb-0 pb-3`}>
                     We go beyond surface-level marketing. Our strategic, story-first approach is built for professionals navigating competitive, high- trust industries. From brand messaging to high-impact campaigns, we help you communicate your value, captivate your audience, and grow with confidence.
                 </p>
                 
                <p className={`body-paragraph color-dark mb-0 pb-3`}>
                  Why work with us? Because we don't do cookie-cutter. We dive deep into your strengths and story, so every move aligns with your vision and voice. It's thoughtful, high-touch, and results-driven.
                </p>
                <p className={`body-paragraph color-dark mb-0 pb-3`}>
                  With expertise supporting top-tier professionals across finance, real estate, wellness and more, Divitiis is your partner in marketing that leaves a mark. Let's craft a story that cuts through and connects.
                </p> */}
                
                <button className={`genral-btn btn-brown mt-3`} onClick={()=>{navigate("/process")}}> See Our Process</button>
            </div>
        </div>
    </div>
  )
}

export default AboutCustomText